export default ({ dropdown }) => ({
  dark: {},
  root: {
    '&$dark': {
      color: dropdown.dark.optionHeader
    },
    color: dropdown.optionHeader,
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '20px',
    height: 20,
    textTransform: 'uppercase',
    width: '100%',
    margin: [-18, 3]
  }
});
